import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { TransferHttpService, CacheItem } from '../../../services/transfer-http/transfer-http.service';
import { AimsCommonTableHeader, AimsCommonTableHeaderType } from '@aims/common-components';

@Component({
  selector: 'reportingTraining',
  templateUrl: './reportingTraining.component.html',
  providers: [],
  styles: ['.printButton { margin-bottom: 5px;}']
})

export class ReportingTrainingComponent {

  constructor(private transferHttp: TransferHttpService,
    private route: ActivatedRoute,
    private router: Router,
    public permissions: PermissionsService) {
  }

  tenantConfig = this.transferHttp.tenantConfig;
  tenantUsesPsc = this.tenantConfig.hr.tenantUsesPsc;

  //***************************
  // Variables
  //***************************

  qualId: number = null;
  qualTaskId: number = null;

  //DropDown Values
  qualValues = this.transferHttp.getSingle(`Tr/GetQualsForPopUp`);
  qualTaskValues = this.transferHttp.getSingle(`Tr/GetQualTasksForPopUp`);

  employeeValues = this.transferHttp.getCache(CacheItem.allEmployees);

  defaultEmployee: { fullName: string, employeeNumber: string } = { fullName: '---select---', employeeNumber: null };

  employee: number;

  qualificationLookupColumns:AimsCommonTableHeader[] = [
    { key: 'qualDesc', label: 'Qualification Description', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'reqByAllEmps', label: 'Required By All Employees?', type: AimsCommonTableHeaderType.BOOLEAN, filter: true },
    { key: 'active', label: 'Active?', type: AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  qualificationTaskLookupColumns:AimsCommonTableHeader[] = [
    { key: 'qtDesc', label: 'Task Description', type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'interval', label: 'Interval In Months',type: AimsCommonTableHeaderType.STRING, filter: true },
    { key: 'hazwoper', label: 'HAZWOPER?', type: AimsCommonTableHeaderType.BOOLEAN, filter: true },
    { key: 'active', label: 'Active?',type: AimsCommonTableHeaderType.BOOLEAN, filter: true }
  ];

  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = true;

  //***************************
  // Functions
  //***************************


  public printAllQualsAndQualTasksRequiredByAllEmps() {
    this.router.navigate([`reporting/TR_AllQualsAndQualTasksRequiredByAllEmps/trdp/`]);
  }

  public printAllQualsAndQualTasksByJobTitle() {
    this.router.navigate([`reporting/TR_AllQualsAndQualTasksByJobTitle/trdp/`]);
  }

  public printAllQualsAndQualTasksByJobAssignment() {
    this.router.navigate([`reporting/TR_AllQualsAndQualTasksByJobAssignment/trdp/`]);
  }

  public printQualsAndQualTasksByJobTitle() {
    this.router.navigate([`reporting/TR_QualsAndQualTasksByJobTitle/trdp/`]);
  }

  public printQualsAndQualTasksByJobAssignment() {
    this.router.navigate([`reporting/TR_QualsAndQualTasksByJobAssignment/trdp/`]);
  }

  public printQualsWithNoEmps() {
    this.router.navigate([`reporting/TR_QualsWithNoEmps/trdp/`]);
  }

  public printQualsWithNoQualTasks() {
    this.router.navigate([`reporting/TR_QualsWithNoQualTasks/trdp/`]);
  }

  public printQualTasksNotAssignedToAnyQual() {
    this.router.navigate([`reporting/TR_QualTasksNotAssignedToAnyQual/trdp/`]);
  }

  public printTrainingHistoryByEmpAndOcc() {
    this.router.navigate([`reporting/TR_ReqByEmpAndJobTitlesByOCC/trdp/`]);
  }

  public printTrainingHistoryByEmpAndJobTitle() {
    this.router.navigate([`reporting/TR_TrainingHistoryByEmpAndJobTitle/trdp/`]);
  }

  public printOverdueOrComingDueByEmp() {
    this.router.navigate([`reporting/TR_OverdueOrComingDueByEmp/trdp/`]);
  }

  public printQualsNotRequiredByEmp() {
    this.router.navigate([`reporting/TR_QualsNotRequiredByEmp/trdp/`]);
  }

  public printQualTasksNotRequiredByEmp() {
    this.router.navigate([`reporting/TR_QualTasksNotRequiredByEmp/trdp/`]);
  }

  public printUnQualifiedQual() {
   this.router.navigate([`reporting/TR_Qual_Unqualified/trdp/{"QualID":"${this.qualId}"}`]);
  }

  public printQualifiedQual() {
    this.router.navigate([`reporting/TR_Qual_Qualified/trdp/{"QualID":"${this.qualId}"}`]);
  }

  public printRequiredQualTask() {
    this.router.navigate([`reporting/TR_QualTask/trdp/{"QualTaskID":"${this.qualTaskId}"}`]);
  }

  public printOverdueOrComingDueQualTask() {
    this.router.navigate([`reporting/TR_OverdueOrComingDueQualTask/trdp/{"QualTaskID":"${this.qualTaskId}"}`]);
  }

  public printSiteOverdueReport() {
    this.router.navigate([`reporting/TR_SiteOverdueTraining/trdp`]);
  }


  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.qualValues.subscribe();
    this.qualTaskValues.subscribe();
  }
}
